import * as React from 'react'
// eslint-disable-next-line import/no-cycle
import { cdnUrl } from 'utils/storyblok'
import StoryblokService from 'utils/storyblok-service'
import QuotesComponent from './Quotes'

export const transformProps = (propsArg) => {
  const props = { ...propsArg }

  props.items = props.items.map((item) => ({
    ...item,
    mediaSrc: (item.mediaSrc?.filename && cdnUrl(item.mediaSrc?.filename)) || undefined,
    content: StoryblokService?.client?.richTextResolver?.render(item.content),
  }))

  return props
}
const Quotes = (props) => <QuotesComponent {...transformProps(props)} />

export default Quotes
